export const PriceMarginPresetLinkCell = ({ value }: { value: any }) => {
    const valueArray = Array.isArray(value) ? value : [];
    
    return (
        <span>
            {valueArray.map((el) => el.priceMarginPreset?.name ?? "").join("; ")}
        </span>
    )
}
